const initialState = {
    roles: [],
	count: 0,
    isReadingRoles: false,
    isReadingRolesNames: false,
    rolesNames: [],
    queryParameters: {
        page: 1,
        limit: 25, 
        offset: 0,
        search:''
    },
    readingDefaultPermissions: false,
    defaultPermissions: {}
};

export default initialState;
